module.exports = "pegasus_template/assets/themelp1/app/105.png";